import { isTauri, localSettingsGet, localSettingsSet } from "./bridge";

// Desktop app preferences persisted NATIVELY in settings.json (so the Rust side can read them at
// startup — e.g. "start maximized" before the webview is useful). This is distinct from the
// localStorage prefs in vault/prefs.ts (transient per-browser UI state): app settings are
// device-wide and must be reachable from native code. On web (non-desktop) these are no-ops.
export interface AppSettings {
  /** Open the window maximized on every launch (read in main.rs .setup()). */
  startMaximized?: boolean;
  /** Closing the window hides it to the system tray instead of quitting (read on close). */
  closeToTray?: boolean;
}

export async function getAppSettings(): Promise<AppSettings> {
  if (!isTauri()) return {};
  try {
    const raw = await localSettingsGet();
    return {
      startMaximized: typeof raw.startMaximized === "boolean" ? raw.startMaximized : undefined,
      closeToTray: typeof raw.closeToTray === "boolean" ? raw.closeToTray : undefined,
    };
  } catch {
    return {};
  }
}

/** Merge a patch into settings.json, preserving keys this module doesn't own (lastLoginHint, etc.). */
export async function setAppSettings(patch: Partial<AppSettings>): Promise<void> {
  if (!isTauri()) return;
  const current = (await localSettingsGet().catch(() => ({}))) as Record<string, unknown>;
  await localSettingsSet({ ...current, ...patch });
}
